var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-n4"},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('employee-claims-payment-bulkpay-card')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }